import { lazy } from "react";

const _mobile = [
        { path: '/mobile/so-do/:phienHopId/:soDoId/:phongHopId', component: lazy(() => import('../../views/mobile/diagram')), viewName: 'Sơ đồ mobile' },
        { path: '/mobile/annotation', component: lazy(() => import('../../views/mobile/annotation')), viewName: 'Ghi chú PDF mobile' },
        { path: "/prepare-info/:isNewUser", component: lazy(() => import("../../views/base/prepareInfo")) },
        { path: '/meeting/:phienHopId', component: lazy(() => import('../../views/don-vi/PhienHop/StartMeeting/MeetingPage')), viewName: 'Họp trực tuyến' },
];

export default _mobile